import type { Category } from '@/validators/procedure'
import { apiClient } from '@/api/base'
import { useQuery } from '@tanstack/react-query'

export function useGetAllCategoriesQuery() {
  return useQuery<Category[]>({
    staleTime: 1000 * 60 * 60, // 60 minutes
    queryKey: ['categories-all-non-paginated'],
    queryFn: async () => {
      const { data } = await apiClient('/api/editor/categories', {})
      return data.data
    },
  })
}
